/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum NewbornInvestigationPeriodState {
    PLANNED = 'planned',
    REQUESTED = 'requested',
    MISSING = 'missing',
    DONE = 'done',
}
